import { useUser } from "@/apis/bff"
import { getIsProgressNoteEditable } from "@/modules/patients/detail/progress-note/lib/get-is-progress-note-editable"
import { ProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"
import { useAppointmentParam, useIsInContextOfAppointment } from "@/modules/patients/hooks/useAppointmentParam"

export const useIsProgressNoteEditable = (progressNote: ProgressNoteData) => {
  const appointmentId = useAppointmentParam()
  const { userName } = useUser()
  const isInContextOfAppointment = useIsInContextOfAppointment()

  return getIsProgressNoteEditable(progressNote, userName, appointmentId, isInContextOfAppointment)
}
